import React from 'react';
import type { ClingMelodyExercise } from '../../lib/melody/clingCantaConfig';
import { CLING_LANE_HEIGHT, CLING_ROLL_PADDING, pitchLaneTop } from '../../lib/melody/clingCantaPitch';

interface ClingConfigMiniRollProps {
  exercise: ClingMelodyExercise;
}

export const ClingConfigMiniRoll: React.FC<ClingConfigMiniRollProps> = ({ exercise }) => {
  const lanes = exercise.lanes;
  const contentH = CLING_ROLL_PADDING * 2 + lanes.length * CLING_LANE_HEIGHT;
  const maxBeat = exercise.notes.reduce((m, n) => Math.max(m, n.beat + n.durationBeats), 1);

  return (
    <div className="cling-config-mini-roll" aria-hidden>
      <div className="cling-config-mini-roll-inner" style={{ height: contentH }}>
        {lanes.map((lane) => (
          <div
            key={lane}
            className="cling-config-mini-roll-lane"
            style={{ top: pitchLaneTop(lane, lanes), height: CLING_LANE_HEIGHT }}
          />
        ))}
        {exercise.notes.map((note, i) => {
          const top = pitchLaneTop(note.pitchId, lanes) + 4;
          const left = `${(note.beat / maxBeat) * 72 + 8}%`;
          const width = `${Math.max(12, (note.durationBeats / maxBeat) * 68)}%`;
          return (
            <div
              key={`${note.pitchId}-${i}`}
              className="cling-config-mini-roll-note"
              style={{ top, left, width }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ClingConfigMiniRoll;
